import { axios } from './axios';

export const blogApi = {
    // Blog CRUD Operations
    getAllBlogs: (params) => {
        return axios.get('/blogs', { params });
    },

    getBlogById: (id) => {
        return axios.get(`/blogs/${id}`);
    },

    getBlogBySlug: (slug) => {
        return axios.get(`/blogs/slug/${slug}`);
    },

    createBlog: (blogData) => {
        return axios.post('/blogs', blogData);
    },

    updateBlog: (id, blogData) => {
        return axios.put(`/blogs/${id}`, blogData);
    },

    deleteBlog: (id) => {
        return axios.delete(`/blogs/${id}`);
    },

    // Blog Categories CRUD Operations
    getAllCategories: () => {
        return axios.get('/blogs/categories');
    },

    getCategoryById: (id) => {
        return axios.get(`/blogs/categories/${id}`);
    },

    createCategory: (categoryData) => {
        return axios.post('/blogs/categories', categoryData);
    },

    updateCategory: (id, categoryData) => {
        return axios.put(`/blogs/categories/${id}`, categoryData);
    },

    deleteCategory: (id) => {
        return axios.delete(`/blogs/categories/${id}`);
    },

    // Blog Tags CRUD Operations
    getAllTags: () => {
        return axios.get('/blogs/tags');
    },

    getTagById: (id) => {
        return axios.get(`/blogs/tags/${id}`);
    },

    createTag: (tagData) => {
        return axios.post('/blogs/tags', tagData);
    },

    updateTag: (id, tagData) => {
        return axios.put(`/blogs/tags/${id}`, tagData);
    },

    deleteTag: (id) => {
        return axios.delete(`/blogs/tags/${id}`);
    },

    // Advanced Search and Filtering
    searchBlogs: (searchTerm, limit = 10) => {
        return axios.get('/blogs/search', {
            params: { q: searchTerm, limit },
        });
    },

    getFeaturedBlogs: (limit = 5) => {
        return axios.get('/blogs/featured', {
            params: { limit },
        });
    },

    getRelatedBlogs: (blogId, categoryId, limit = 3) => {
        return axios.get('/blogs/related', {
            params: { blogId, categoryId, limit },
        });
    },

    getBlogsByCategory: (categorySlug, page = 1, limit = 10) => {
        return axios.get(`/blogs/category/${categorySlug}`, {
            params: { page, limit },
        });
    },

    getBlogsByTag: (tagSlug, page = 1, limit = 10) => {
        return axios.get(`/blogs/tag/${tagSlug}`, {
            params: { page, limit },
        });
    },
};
